var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-wrap"},[_c('div',{staticClass:"btns_1"},[_vm._v("【初级会计实务】交卷完成。")]),_c('div',{staticClass:"btns_2"},[_vm._v("确定（"+_vm._s(_vm.countdownTime)+"秒）")])])
}
var staticRenderFns = []

export { render, staticRenderFns }